export default __webpack_public_path__ + "static/media/view-reports@2x.b8231073.png";